import React from 'react';
import { SimpleModal } from '../../../../components/SimpleModal';
import { WarningModal } from '../../../../components/Icons';
import { Button, LoadingOverlay } from '../../../../components';
import useOnCloseSchedule from '../../../../hooks/useOnCloseSchedule';
import { useCareplusRouter } from '../../router/context';

export const PendingSchedulePage = () => {
  const [loading, setLoading] = React.useState(false);
  const { onCloseSchedule } = useOnCloseSchedule({});
  const { goBack } = useCareplusRouter();

  const sendToCockpit = async () => {
    setLoading(r => !r);

    onCloseSchedule();

    setLoading(r => !r);
  };

  return (
    <>
      <SimpleModal
        visible={true}
        onClose={goBack}
        mainIcon={<WarningModal />}
        title="Agendamento pendente"
        subtitle="Entraremos em contato para dar continuidade ao seu agendamento."
        customFooterContainer={
          <>
            <Button type="button" title="Voltar para home" onClick={sendToCockpit} />
          </>
        }
      />
      <LoadingOverlay loading={loading} />
    </>
  );
};
